<div class="col-12">
  <div class="card">
    <div class="card-header">
      <div class="card-title">
        <div class="input-group input-group-sm" style="width: 250px;">
          <select type="text" name="table_search" [(ngModel)]="sortby" class="form-control float-right">
            <option value="status">Status</option>
            <option value="followup_date">followup_date</option>
          </select>

          <div class="input-group-append">
            <button type="submit" class="btn btn-default">
              <i class="fas fa-sort"></i>
            </button>
          </div>

          <div class="input-group-append">
            <button type="submit" class="btn btn-default">Export
              <i class="fas fa-download"></i>
            </button>
          </div>
        </div>

      </div>

      <div class="card-tools">
        <div class="input-group input-group-sm" style="width: 250px;">
          <input type="text" name="table_search" [(ngModel)]="searchString" class="form-control float-right" placeholder="Search">

          <div class="input-group-append">
            <button type="submit" class="btn btn-default" (click)="refresh();">
              Refresh
            </button>
          </div>
        </div>

      </div>
    </div>
    <div class="card-body table-responsive p-0" style="height: 410px;"
    *ngIf="leads.length > 0 && !isloading">
      <table class="table table-head-fixed text-nowrap">
        <thead>
          <tr>
            <th>Customer Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th *ngIf="user.role === 'admin' || user.role === 'manager' ">Sales Officer</th>
            <th>Follow Up Date</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let lead of leads | filter: searchString: 'status' | sort: [ sortby,''] ">
            <td>{{ lead.name }}</td>
            <td>{{ lead.contact_1 }}</td>
            <td>{{ lead.email }}</td>
            <td>{{ lead.sale_person?.name }}</td>
            <td>{{ lead.followup_date| date:'fullDate' }}</td>
            <td>{{ lead.status }}</td>
            <td>
              <a class="btn" (click) = "edit(lead)"><i class="fas fa-edit"></i></a>
              <a class="btn" (click) = "info(lead)"><i class="fas fa-info"></i></a>
              <a class="btn" (click)="delete(lead)"
              *ngIf="user.role === 'admin' || user.role === 'manager' ">
                <i class="fas fa-trash"></i></a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="col-12" style="padding-top: 20px;" *ngIf="isloading">
  <p class="text-center">loading ...</p>
</div>

<div class="col-12" style="padding-top: 100px;" *ngIf="leads.length == 0 && !isloading">
  <h3 class="text-center">No Leads For Now</h3>
  <div class="text-center">
    <button type="submit" class="btn btn-default" (click)="refresh();">
      Refresh
    </button>
  </div>
</div>

<div class="input-group-append" style="display: none;">
  <button type="submit" class="btn btn-default" id="btn" data-toggle="modal" data-target="#formModal">
    <i class="fas fa-create"></i> Update
  </button>
</div>

<div class="modal fade" id="formModal" tabindex="-1" role="dialog" aria-labelledby="formModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="formModalTitle">Manage Lead</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close_btn">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="leadForm" (ngSubmit)="onSubmit()" #documentEditForm="ngForm">
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="status">Status</label>
              <select class="form-control" name="status" formControlName="status">
                <option value="follow up">Follow Up</option>
                <option value="close">Close</option>
                <option value="new" disabled>New</option>
              </select>
            </div>
            <div class="form-group col-md-12">
              <label for="followup_date">Next Follow Up Date</label>
              <div class="input-group">
                <div class="input-group-prepend" (click)="dp.toggleCalendar()">
                  <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                </div>
                <input class="form-control" placeholder="Select a date" angular-mydatepicker   name="followup_date" (click)="dp.toggleCalendar()" autocomplete="off"
                  formControlName="followup_date"[options]="myOptions" #dp="angular-mydatepicker"/>
              </div>
            </div>
          </div>

        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" (click)="documentEditForm.ngSubmit.emit()">
          <span>Save</span>
        </button>
      </div>

    </div>
  </div>
</div>


<!-- Button trigger for Details modal -->
<button style="display: none;" type="button" id="info-btn" class="btn btn-primary" data-toggle="modal"
  data-target="#detailsModal">
  Display Info
</button>

<!-- Details Modal -->
<div class="modal fade" id="detailsModal" tabindex="-1" role="dialog" aria-labelledby="detailsModalTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 40%;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="detailsModalTitle" >Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table" *ngIf="leadDetails">
          <tbody>
            <tr>
              <th scope="row">Customer Name</th>
              <td>{{leadDetails.name}}</td>
            </tr>
            <tr>
              <th scope="row">Contact Number</th>
              <td>{{leadDetails.contact_1}}</td>
            </tr>
            <tr>
              <th scope="row">Alternate Contact Number</th>
              <td>{{leadDetails.contact_2}}
              </td>
            </tr>
            <tr>
              <th scope="row">Email</th>
              <td>{{leadDetails.email}}</td>
            </tr>
            <tr>
              <th scope="row">Occupation</th>
              <td>{{leadDetails.job}}</td>
            </tr>
            <tr>
              <th scope="row">Address</th>
              <td>{{leadDetails.address}}</td>
            </tr>
            <tr>
              <th scope="row">Source</th>
              <td>{{leadDetails.source}}</td>
            </tr>
            <tr>
              <th scope="row">Remarks</th>
              <td>{{leadDetails.note}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>

